import { createMuiTheme } from '@material-ui/core/styles'
import { theme } from "./theme"

const overrideTheme = createMuiTheme({
    overrides: {
        MuiAppBar: {
            root: {
                boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.1),0px 2px 2px 0px rgba(0,0,0,0.07),0px 1px 5px 0px rgba(0,0,0,0.06)'
            },
            colorPrimary: {
                backgroundColor: theme.palette.grey['50'],
                color: theme.palette.text.secondary
            },
        },
        MuiBackdrop: {
            root: {
                backgroundColor: "rgba(255, 255, 255, 0.54)"
            }
        },
        MuiButton: {
            root: {
                minWidth: 180
            },
            outlined: {
                color: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,
                borderRadius: theme.shape.borderRadius,
                backgroundColor: theme.palette.common.white,
                padding: theme.spacing(1.5)
            },
            contained: {
                color: theme.palette.common.white,
                backgroundColor: theme.palette.primary.main,
                borderRadius: theme.shape.borderRadius,
                padding: theme.spacing(1.5)
            },
            text: {
                padding: 0
            }
        },
        MuiCardMedia: {
            media: {
                transform: 'translate3d(0,0,0) scale(.755)',
                backfaceVisibility: 'hidden',
                imageRendering: '-webkit-optimize-contrast',
                transition: 'transform 320ms ease',
                transitionProperty: 'transform, opacity, -webkit-transform',

                "&:hover": {
                    transform: 'translate3d(0,0,0) scale(.855)',
                },

                "&:active": {
                    transform: 'translate3d(0,0,0) scale(.855)'
                }
            }
        },
        MuiCheckbox: {
            colorSecondary: {
                color: theme.palette.primary.main,
            }
        },
        MuiDialogActions: {
            root: {
                marginTop: '2rem',
                marginBottom: '2rem',
                justifyContent: 'flext-start'
            }
        },
        MuiFormControlLabel: {
            label: {
                fontFamily: 'Muli'
            }
        },
        MuiInput: {
            input: {
                "&::placeholder": {
                    textAlign: 'center',
                    fontSize: '2rem',
                    lineHeight: '2.4rem',
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                },
                fontSize: '2rem',
            },
            underline: {
                '&:before': {
                    borderBottom: '2px solid rgba(0,0,0,0.42)',
                }
            }
        },
        MuiLink: {
            underlineAlways: {
                cursor: 'pointer'
            },
            underlineHover: {
                cursor: 'pointer'
            }
        },
        MuiStepLabel: {
            label: {
                "&.MuiStepLabel-active" : {
                    color: theme.palette.primary.main,
                    fontWeight: 'bold'
                }
            }
        },
        MuiStepConnector: {
            vertical: {
                paddingBottom: 0
            }
        },
        MuiTab: {
            wrapper: {
                flexDirection: 'row',
                textAlign: 'left',
                fontSize: '1.1rem',
                fontWeight: 400,
                maxWidth: '10rem',
                '@media (max-width:960px)': {
                    fontSize: '0.9rem',
                    maxWidth: '5rem',
                }
            }
        },
        MuiTableCell: {
            root: {
                borderBottom: 'none'
            },
            stickyHeader: {
                backgroundColor: theme.palette.background.paper
            },
            sizeSmall: {
                '&:last-child': {
                    paddingRight: 'inherit'
                }
            }
        },
        MuiTypography: {
            h2: {
                margin: 0
            },
            h3: {
                margin: 0
            },
            h5: {
                margin: 0
            },
            h6: {
                margin: 0
            },
            body1: {
                color: theme.palette.text.primary
            },
        },
    },
})

export default overrideTheme
